var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.667 10a8.333 8.333 0 1 1 16.666 0 8.333 8.333 0 1 1-16.667 0m10.858 2.525a.625.625 0 0 1-.883 0L10 10.883l-1.642 1.642a.625.625 0 0 1-.883-.883L9.117 10 7.475 8.358a.625.625 0 0 1 .883-.883L10 9.117l1.642-1.642a.625.625 0 0 1 .883.883L10.883 10l1.642 1.642a.625.625 0 0 1 0 .883",
    clipRule: "evenodd"
  })));
};
export default SvgCloseCircle;